import { PlusIcon } from "@heroicons/react/24/outline";
import { useState } from "react";

import { Button } from "V2.0/common/button";

import DocumentAddForm from "./DocumentAddForm";

export default function DocumentAdd(props) {
  const { onDocumentAdd } = props;
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Button onClick={() => setIsOpen(true)}>
        <PlusIcon />
        Document
      </Button>
      {isOpen && (
        <DocumentAddForm
          onDocumentAdd={onDocumentAdd}
          open={isOpen}
          onClose={() => setIsOpen(false)}
        />
      )}
    </>
  );
}
